export function getScore(score: string | undefined) {
    switch (score) {
        case 'A1':
            return {score: 'A1', color: '#84cc16', description: 'Créditos de riesgo normal categoría A-1'};
        case 'A2':
            return {score: 'A2', color: '#a3e635', description: 'Créditos de riesgo normal categoría A-2'};
        case 'A3':
            return {score: 'A3', color: '#a3e635', description: 'Créditos de riesgo normal categoría A-3'};
        case 'B1':
            return {score: 'B1', color: '#fde047', description: 'Créditos con riesgo potencial categoría B-1'};
        case 'B2':
            return {score: 'B2', color: '#fde047', description: 'Créditos con riesgo potencial categoría B-2'};
        case 'C1':
            return {score: 'C1', color: '#eab308', description: 'Créditos deficientes categoría C-1'};
        case 'C2':
            return {score: 'C2', color: '#eab308', description: 'Créditos deficientes categoría C-2'};
        case 'D':
            return {score: 'D', color: '#ef4444', description: 'Créditos de dudoso recaudo categoría D'};
        case 'E':
            return {score: 'E', color: '#ef4444', description: 'Pérdidas categoría E'};
        case 'AL':
            return {
                score: 'AL',
                color: '#ef4444',
                description: 'Sin calificación (Cuando la institución del Sistema Financiero y de Seguridad Social cuente con garantías auto liquidables que cubran el cien por ciento del saldo del crédito otorgado).'
            };
        case 'N':
            return {
                score: 'N',
                color: '#cbd5e1',
                description: 'Sin calificación (solo para operaciones con acuerdo concordatario)'
            };
        default:
            return {score: '', color: '#cbd5e1', description: ''};
    }
}